import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { IBaseRequestParams } from '../../../store/types/Request.types';

import { ICodeErrorResponse, IResponseCodeParams } from './code.types';

const PREFIX = 'CODE';

export const checkCodeRequest = createAction<{ code: string }>(`${PREFIX}/CHECK_CODE_REQUEST`);
export const checkCodeSuccess = createAction(`${PREFIX}/CHECK_CODE_SUCCESS`);
export const checkCodeFail = createAction<TLegacyErrors>(`${PREFIX}/CHECK_CODE_FAIL`);

export const processLinkRequest = createAction<string>(`${PREFIX}/PROCESS_LINK_REQUEST`);
export const processLinkSuccess = createAction<string>(`${PREFIX}/PROCESS_LINK_SUCCESS`);
export const processLinkFail = createAction<TLegacyErrors>(`${PREFIX}/PROCESS_LINK_FAIL`);

export const codeParamsRequest = createAction<IBaseRequestParams>(`${PREFIX}/CODE_PARAMS_REQUEST`);
export const codeParamsSuccess = createAction<IResponseCodeParams>(`${PREFIX}/CODE_PARAMS_SUCCESS`);
export const codeParamsFail = createAction<TLegacyErrors>(`${PREFIX}/CODE_PARAMS_FAIL`);

export const resetCodeError = createAction<void>(`${PREFIX}/RESET_CODE_ERROR`);
export const setCodeError = createAction<ICodeErrorResponse>(`${PREFIX}/SET_CODE_ERROR`);
export const setRedirectUrl = createAction<string>(`${PREFIX}/SET_REDIRECT_URL`);
